<template>
  <div>
    <DadosGerais :formData="formData" :dominios="dominios" />

    <FotosDocumentos
      :formData="formData"
      :arquivos="formData.arquivosDadosGerais"
      :idReferente="idReferenteEvento"
    />

    <LocalEventoForm :formData="formData" />

    <CarroReservaForm :formData="formData" />

    <CondutorForm :formData="formData" :dominios="dominios" />
  </div>
</template>

<script>
import DadosGerais from './components/DadosGeraisForm.vue';
import CarroReservaForm from './components/CarroReservaForm.vue';
import CondutorForm from './components/CondutorForm.vue';
import FotosDocumentos from './../../../shared/components/FotosDocumentos.vue';
import LocalEventoForm from './../../../shared/components/LocalEventoForm.vue';
import { FOTO_REFERENTE_EVENTO } from './../../../shared/const';

export default {
  props: ['formData', 'dominios'],
  components: {
    DadosGerais,
    CarroReservaForm,
    CondutorForm,
    FotosDocumentos,
    LocalEventoForm,
  },
  data() {
    return {
      idReferenteEvento: FOTO_REFERENTE_EVENTO,
    };
  },
};
</script>
